import React from 'react';

import classNames from 'classnames';

const t = require('views/internal/recup-with-helpers')('home');

import styles from './feature-feedback-link.less';

interface FeatureFeedbackLinkProps {
  feedbackLinkUrl: string;
  onFeedbackLinkClick?: () => void;
  onDismissIconClick?: () => void;
}

export const FeatureFeedbackLink: React.StatelessComponent<
  FeatureFeedbackLinkProps
> = ({ feedbackLinkUrl, onFeedbackLinkClick, onDismissIconClick }) => (
  <div className={styles.feedbackContainer}>
    <span>
      <span>{t.l('feature-feedback-info')}</span>
      <a
        className={styles.feedbackLink}
        href={feedbackLinkUrl}
        onClick={onFeedbackLinkClick}
        rel="noopener noreferrer"
        target="_blank"
      >
        {t.l('feature-feedback-link-text')}
      </a>
    </span>
    <button className={styles.dismissButtonIcon} onClick={onDismissIconClick}>
      <span className={classNames('icon-sm', 'icon-close')} />
    </button>
  </div>
);



// WEBPACK FOOTER //
// ./app/scripts/views/home/presentational/feature-feedback-link.tsx